function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4142 6.58579C16.1953 7.36683 16.1953 8.63317 15.4142 9.41421C14.6332 10.1953 13.3668 10.1953 12.5858 9.41421C11.8047 8.63317 11.8047 7.36683 12.5858 6.58579C13.3668 5.80474 14.6332 5.80474 15.4142 6.58579Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.4142 6.58579C10.1952 7.36683 10.1952 8.63317 9.4142 9.41421C8.63316 10.1953 7.36683 10.1953 6.58578 9.41421C5.80474 8.63317 5.80474 7.36683 6.58578 6.58579C7.36683 5.80474 8.63316 5.80474 9.4142 6.58579Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.41421 6.58579C4.19525 7.36683 4.19525 8.63317 3.41421 9.41421C2.63316 10.1953 1.36683 10.1953 0.585784 9.41421C-0.195261 8.63317 -0.195261 7.36683 0.585784 6.58579C1.36683 5.80474 2.63316 5.80474 3.41421 6.58579Z",
  fill: "currentColor"
});

var SvgMore = function SvgMore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/more.e429f0f2.svg";
export { ForwardRef as ReactComponent };